import Button from 'components/_parts/atoms/button';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Contact from 'assets/img/contact.svg';

function Footer() {
  const { t } = useTranslation();
  const handleShowTawkTo = () => {
    if (!window.Tawk_API) return;

    window.Tawk_API.maximize();
  };

  return (
    <footer className="footer tw-relative">
      <div className="container-fluid">
        <div className="row text-muted">
          <div className="col-6 text-left">
            <p className="mb-0">
              &copy;
              {' '}
              <a href="index.html" className="text-muted">
                {t('board.copyright')}
              </a>
            </p>
          </div>
          <div className="col-6 text-right" style={{ paddingRight: '160px' }}>
            <ul className="list-inline">
              <li className="list-inline-item">
                <Link
                  className="text-muted"
                  to={{
                    pathname: 'https://betterandco.com/tentang-kami/',
                  }}
                  target="_blank"
                >
                  {t('board.about_us')}
                  {' |'}
                </Link>
              </li>
              <li className="list-inline-item">
                <Link
                  className="text-muted"
                  target="_blank"
                  to={{
                    pathname: 'https://supportrize.tawk.help/',
                  }}
                >
                  {t('board.help')}
                  {' |'}
                </Link>
              </li>
              <li className="list-inline-item">
                <Link className="text-muted" target="_blank" to="/terms-and-condition">
                  {t('board.tnc')}
                  {' |'}
                </Link>
              </li>
              <li className="list-inline-item">
                <Button
                  func={handleShowTawkTo}
                  style={{
                    fontSize: '14px', fontWeight: '400', padding: '4px 10px', marginLeft: '12px'
                  }}
                >
                  <img src={Contact} alt="contact icon" style={{ width: '18px', height: '18px' }} />
                  <span className="tw-ml-[5px]">{t('footer.chatUs')}</span>
                </Button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default memo(Footer);
